'use client';

import { notFound } from 'next/navigation';
import type { ReactNode } from 'react';

import { useFeatureGate } from '@/hooks/use-feature-gate';
import { useCompetitionPublicAccess } from './competition-public-access';

export function CompetitionsGate({
  children,
  loading,
}: {
  children: ReactNode;
  loading: ReactNode;
}): ReactNode {
  const enabled = useFeatureGate('trading_competitions');
  const publiclyAvailable = useCompetitionPublicAccess();
  if (publiclyAvailable) return children;
  if (enabled === null) return loading;
  if (!enabled) notFound();
  return children;
}
